import React from 'react';

function Portfolio() {
  return (
    <section className="portfolio-clean section-padding pt-0">
      <div className="container">
        <div className="row">
          <div className="col-lg-5">
            <div className="item mb-30">
              <div className="img">
                <img src="/dark/assets/imgs/works/2/1.jpg" alt="" />
                <div className="cont d-flex align-items-center">
                  <div>
                    <h5>Nice guy with a smile</h5>
                    <p>Graphic Designing</p>
                  </div>
                  <div className="ml-auto">
                    <a href="/dark/project1" className="rmore">
                      <img
                        src="/dark/assets/imgs/arrow-right.png"
                        alt=""
                        className="icon-img-20"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="item mb-30">
              <div className="img">
                <img src="/dark/assets/imgs/works/2/2.jpg" alt="" />
                <div className="cont d-flex align-items-center">
                  <div>
                    <h5>Nice guy with a smile</h5>
                    <p>Graphic Designing</p>
                  </div>
                  <div className="ml-auto">
                    <a href="/dark/project2" className="rmore">
                      <img
                        src="/dark/assets/imgs/arrow-right.png"
                        alt=""
                        className="icon-img-20"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="item md-mb30">
              <div className="img">
                <img src="/dark/assets/imgs/works/2/3.jpg" alt="" />
                <div className="cont d-flex align-items-center">
                  <div>
                    <h5>Nice guy with a smile</h5>
                    <p>Graphic Designing</p>
                  </div>
                  <div className="ml-auto">
                    <a href="/dark/project3" className="rmore">
                      <img
                        src="/dark/assets/imgs/arrow-right.png"
                        alt=""
                        className="icon-img-20"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="item md-mb30">
              <div className="img">
                <img src="/dark/assets/imgs/works/2/4.jpg" alt="" />
                <div className="cont d-flex align-items-center">
                  <div>
                    <h5>Nice guy with a smile</h5>
                    <p>Graphic Designing</p>
                  </div>
                  <div className="ml-auto">
                    <a href="/dark/project4" className="rmore">
                      <img
                        src="/dark/assets/imgs/arrow-right.png"
                        alt=""
                        className="icon-img-20"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="item">
              <div className="img">
                <img src="/dark/assets/imgs/works/2/5.jpg" alt="" />
                <div className="cont d-flex align-items-center">
                  <div>
                    <h5>Nice guy with a smile</h5>
                    <p>Graphic Designing</p>
                  </div>
                  <div className="ml-auto">
                    <a href="/dark/project5" className="rmore">
                      <img
                        src="/dark/assets/imgs/arrow-right.png"
                        alt=""
                        className="icon-img-20"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
